<template>
  <div v-if="customIsVisible" :class="[backgroundColor, bottomMargin, verticalPadding, background]" class="faqs">
    <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12">
      <VcTypography v-if="title" :tag="heading" :anchor-id="title" class="w-full mb-8">
        {{ title }}
      </VcTypography>
      <VcWidget
        v-for="faq in faqs"
        collapsible
        :title="faq.question"
        collapsed
        class="shadow-none mb-2 border-[--color-gray-line]"
      >
        <template #default-container>
          <div class="answer px-6 pb-6">
            <VcMarkdownRender :src="getAnswer(faq.answer)" />
            <div v-if="hasTextlink(faq)" class="flex h-6 mt-2 items-end">
              <!-- Innovadis custom: sanitize FAQ external URL before binding to href -->
              <a
                v-if="isExternalLink(faq)"
                target="_blank"
                class="text-[--color-link] text-sm font-semibold"
                rel="noopener noreferrer"
                :href="getSafeUrl(faq.linkUrl)"
              >
                {{ faq.linkLabel }}
              </a>
              <router-link v-else :to="faq.linkUrl || '#'">
                <span class="text-[--color-link] text-base font-semibold">{{ faq.linkLabel }}</span>
              </router-link>
            </div>
          </div>
        </template>
      </VcWidget>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getSafeUrl } from "@/core/utilities/url/safeUrl";
import { getLinkAttr } from "@/core/utilities/common";

type Faq = {
  question: string;
  answer: string;
  linkLabel?: string;
  linkUrl?: string;
};

interface IProps {
  id: string;
  heading?: string;
  title?: string;
  faqs?: Faq[];

  background?: string;
  model: any;
  settings: any;

  // Innovadis custom: Use custom visibility setting
  customIsVisible: boolean;

  // Innovadis custom: Use custom layout settings
  backgroundColor: string;
  bottomMargin: string;
  verticalPadding: string;
}

function getAnswer(answer: any) {
  return typeof answer === "object" ? answer?.html : answer.text;
}

function hasTextlink(faq: Faq) {
  return !!faq.linkLabel?.trim() && !!faq.linkUrl?.trim();
}

function isExternalLink(faq: Faq) {
  return "externalLink" in getLinkAttr(faq.linkUrl);
}

withDefaults(defineProps<IProps>(), {
  heading: "h2",
});
</script>
<style lang="scss">
.faqs .answer p {
  width: 100%;
}
</style>
